// middleware/antiBot.js
export default function (context) {
  if(context&&context.req&&context.req.headers) {
    const userAgent = context.req.headers['sec-ch-ua']|| context.req.headers['user-agent'] || '';
    // console.log(userAgent, secCHUA,8888988888);
    if (/HeadlessChrome/.test(userAgent) || !userAgent) {
      context.res.writeHead(403, { 'Content-Type': 'text/html; charset=utf-8' });
      context.res.end('网络异常，请刷新页面重试');
    }
  }
}